import { createAsyncThunk } from "@reduxjs/toolkit";
import { createVoucher, editVoucher, getVoucherId, getVouchers, toggleVoucher, uploadFile } from "helpers/backend_helper";

type VoucherParams = {
    page: number;
    count: number;
    keyword: string;
    keywordType: string; 
    status: string;      
};
  
  export const getVouchersThunk = createAsyncThunk(
    "vouchers/getVouchers",
    async (
      params: VoucherParams,
      { rejectWithValue }
    ) => {
      try {
        const response = await getVouchers(
          params.page,
          params.count,
          params.keyword,
          params.keywordType,
          params.status
        );
        return response.data;
      } catch (error) {
        return rejectWithValue("Something went wrong while fetching vouchers.");
      }
    }
  );
  
  export const createVoucherConfig = createAsyncThunk("voucher/createVoucherConfig", async (formData: any) => {
    try {
      const response = await createVoucher(formData);
      return response;
    } catch (error) {
      return { isSuccess: false, message: "Please! fill out the complete form" };
    }
  });

  export const uploadFileCsv = createAsyncThunk(
    "voucher/uploadVoucherConfig",
    async (formData: FormData) => {
      try {
        const response = await uploadFile(formData); 
        return response;
      } catch (error) {
        return { isSuccess: false, message: "Please! fill out the complete form" };
      }
    }
  );

    export const activateVoucher = createAsyncThunk("voucher/toggle",async ({id}: {
        id: string;
      }) => {
        try {
          const response = await toggleVoucher(id);
          return response.data;
        } catch (error) {
          throw error;
        }
      }
)
    
export const fetchVoucherDetail = createAsyncThunk(
  "Voucher/fetchVoucherDetail",
  async (id: any | number, { rejectWithValue }) => {  
    try {
      const response = await getVoucherId(id);  
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const clearVoucherDetail = createAsyncThunk(
  "Voucher/clearVoucherDetail",
  async (_, { fulfillWithValue }) => {
    return fulfillWithValue({
      voucherData: null,
      counts: 0,
      error: null
    });
  }
);

export const editVoucherConfig = createAsyncThunk("voucher/editVoucherConfig", async (formData: any) => {
  try {
    const response = await editVoucher(formData);
    return response;
  } catch (error) {
    return { isSuccess: false, message: "Please! fill out the complete form" };
  }
});